import { render } from "./HumanResourcesIndex.vue?vue&type=template&id=ddd16444"
import script from "./HumanResourcesIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./HumanResourcesIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/HR/HumanResourcesIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ddd16444"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ddd16444', __exports__)) {
    api.reload('ddd16444', __exports__)
  }
  
  module.hot.accept("./HumanResourcesIndex.vue?vue&type=template&id=ddd16444", () => {
    api.rerender('ddd16444', render)
  })

}


export default __exports__